import React, { useEffect, useState } from "react";
import HeaderOne from "../components/header/HeaderOne";
import FooterOne from "../components/footer/FooterOne";
import Breadcrumb from "./Breadcrumb";

const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5000"
).replace(/\/+$/, "");

function HumanResources() {
  const [selectedFile, setSelectedFile] = useState(null);

  const [fileError, setFileError] = useState("");

  const [formMessage, setFormMessage] = useState("");

  const [formMessageType, setFormMessageType] = useState("");

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isConsentChecked, setIsConsentChecked] = useState(false);
  const [successPopupOpen, setSuccessPopupOpen] = useState(false);
  const [applicantName, setApplicantName] = useState("");
  const [contractModalOpen, setContractModalOpen] = useState(false);

  const [contractLoading, setContractLoading] = useState(false);

  const [contractError, setContractError] = useState("");

  const [contractData, setContractData] = useState({
    title: "",
    editor: "",
  });

  const breadcrumbs = [
    { label: "Ana Sayfa", link: "/" },
    { label: "İnsan Kaynakları" },
  ];

  const cleanPersonName = (value = "") => {
    return String(value)
      .replace(/[^A-Za-zÇĞİÖŞÜçğıöşüÂâÎîÛû' -]/g, "")
      .replace(/\s{2,}/g, " ");
  };

  const formatHrPhone = (value = "") => {
    let digits = String(value).replace(/\D/g, "");

    // 90 ile yapıştırılırsa kaldır
    if (digits.startsWith("90")) {
      digits = digits.slice(2);
    }

    // 0 ile başlarsa kaldır
    if (digits.startsWith("0")) {
      digits = digits.slice(1);
    }

    digits = digits.slice(0, 10);

    const firstPart = digits.slice(0, 3);
    const secondPart = digits.slice(3, 6);
    const thirdPart = digits.slice(6, 8);
    const fourthPart = digits.slice(8, 10);

    return [firstPart, secondPart, thirdPart, fourthPart]
      .filter(Boolean)
      .join(" ");
  };

  const handlePersonNameInput = (event) => {
    event.target.value = cleanPersonName(event.target.value);
  };

  const handleHrPhoneInput = (event) => {
    event.target.value = formatHrPhone(event.target.value);
  };

  const handleHrEmailInput = (event) => {
    event.target.value = event.target.value.replace(/\s/g, "").toLowerCase();
  };

  /*
|--------------------------------------------------------------------------
| AYDINLATMA METNİ
|--------------------------------------------------------------------------
*/
  const openContractModal = async () => {
    setContractModalOpen(true);
    setContractLoading(true);
    setContractError("");

    try {
      const response = await fetch(`${API_BASE_URL}/api/contract/394`);

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        throw new Error(
          data?.message || data?.msg || "Aydınlatma metni alınamadı.",
        );
      }

      setContractData({
        title: data?.title || "Aydınlatma Metni",
        editor: data?.editor || "",
      });
    } catch (error) {
      console.error("CONTRACT_DETAIL_ERROR:", error);

      setContractError("Aydınlatma metni yüklenirken bir hata oluştu.");
    } finally {
      setContractLoading(false);
    }
  };

  const closeContractModal = () => {
    setContractModalOpen(false);
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];

    setFileError("");
    setFormMessage("");
    setFormMessageType("");
    setSelectedFile(null);

    if (!file) {
      return;
    }

    const allowedExtensions = ["pdf", "doc", "docx"];

    const extension = file.name.split(".").pop()?.toLowerCase();

    if (!allowedExtensions.includes(extension)) {
      event.target.value = "";

      setFileError("CV dosyası PDF, DOC veya DOCX formatında olmalıdır.");

      return;
    }

    const maximumSize = 5 * 1024 * 1024;

    if (file.size > maximumSize) {
      event.target.value = "";

      setFileError("CV dosyasının boyutu en fazla 5 MB olabilir.");

      return;
    }

    setSelectedFile(file);
  };
  useEffect(() => {
    if (!contractModalOpen) {
      return;
    }

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closeContractModal();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", handleKeyDown);

      document.body.style.overflow = "";
    };
  }, [contractModalOpen]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSubmitting) {
      return;
    }

    const formElement = event.currentTarget;

    setFileError("");
    setFormMessage("");
    setFormMessageType("");

    /*
     * HTML required kontrollerini çalıştırır.
     */
    if (!formElement.checkValidity()) {
      formElement.reportValidity();
      return;
    }

    if (!selectedFile) {
      setFileError("Lütfen CV dosyanızı yükleyiniz.");

      return;
    }

    try {
      setIsSubmitting(true);

      const formData = new FormData(formElement);

      /*
       * Seçilen CV dosyasının kesin olarak
       * cv alanında gönderilmesini sağlar.
       */
      formData.set("cv", selectedFile);

      const searchParams = new URLSearchParams(window.location.search);

      const currentLang = searchParams.get("lang") || "tr";

      formData.set("lang", currentLang);

      const response = await fetch(
        `${API_BASE_URL}/api/contact/send-career-application`,
        {
          method: "POST",

          /*
           * Content-Type yazma.
           * Tarayıcı multipart/form-data boundary
           * değerini kendisi oluşturur.
           */
          body: formData,
        },
      );

      const responseData = await response.json().catch(() => ({}));

      if (!response.ok || responseData.success === false) {
        throw new Error(responseData.message || "Başvuru gönderilemedi.");
      }

      const firstName = formData.get("name") || "";
      const lastName = formData.get("surname") || "";
      const submittedName = `${firstName} ${lastName}`.trim();

      formElement.reset();

      setSelectedFile(null);
      setFileError("");
      setIsConsentChecked(false);
      setFormMessageType("success");
      setFormMessage(
        responseData.message || "Başvurunuz başarıyla gönderildi.",
      );
      setApplicantName(submittedName);
      setSuccessPopupOpen(true);
    } catch (error) {
      console.error("CAREER_APPLICATION_ERROR:", error);

      setFormMessageType("error");

      setFormMessage(error.message || "Başvuru gönderilirken bir hata oluştu.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const closeSuccessPopup = () => setSuccessPopupOpen(false);

  useEffect(() => {
    if (!successPopupOpen) return;
    const onKey = (e) => { if (e.key === "Escape") closeSuccessPopup(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [successPopupOpen]);

  return (
    <div>
      <style>
        {`
                    /*
                     * Tema başlıklarının arkasındaki soluk büyük yazıları kaldırır.
                     */
                    .demirsan-hr-clean-title {
                        position: relative !important;
                        background: none !important;
                        background-image: none !important;
                    }

                    .demirsan-hr-clean-title::before,
                    .demirsan-hr-clean-title::after,
                    .demirsan-hr-clean-title .pre-title::before,
                    .demirsan-hr-clean-title .pre-title::after,
                    .demirsan-hr-clean-title .title::before,
                    .demirsan-hr-clean-title .title::after,
                    .demirsan-hr-clean-title p::before,
                    .demirsan-hr-clean-title p::after,
                    .demirsan-hr-clean-title h1::before,
                    .demirsan-hr-clean-title h1::after,
                    .demirsan-hr-clean-title h2::before,
                    .demirsan-hr-clean-title h2::after {
                        content: none !important;
                        display: none !important;
                        visibility: hidden !important;
                        opacity: 0 !important;
                        background: none !important;
                        background-image: none !important;
                    }

                    .demirsan-hr-clean-title .pre-title {
                        position: relative;
                        z-index: 2;
                        margin: 0 0 8px;
                        padding: 0 !important;
                        color: #e60000 !important;
                        font-size: 18px !important;
       

                        background: none !important;
                    }

                    .demirsan-hr-clean-title .title {
                        position: relative;
                        z-index: 2;
                        margin: 0;
                        color: #0b1735 !important;
                        background: none !important;
                    }

                    /*
                     * İnsan kaynakları ana alanı
                     */
                    .demirsan-hr-area {
                        padding: 30px 0;
                        background-color: #ffffff;
                    }

                    .demirsan-hr-intro {
                        max-width: 800px;
                        margin: 16px auto 0;
                        color: #5c6678;
                        font-size: 17px;
                        line-height: 1.7;
                    }

                    .demirsan-hr-row {
                        margin-top: 20px;
                        align-items: stretch;
                    }

                    .demirsan-hr-row > div {
                        display: flex;
                    }

                    /*
                     * Sol bilgi alanı
                     */
                    .demirsan-hr-info {
                        position: relative;
                        width: 100%;
                        min-height: 100%;
                        padding: 55px 45px;
                        overflow: hidden;
                        border-radius: 10px;
                        background-color: #0b1735;
                    }

                    .demirsan-hr-info::after {
                        content: "";
                        position: absolute;
                        right: -90px;
                        bottom: -90px;
                        width: 230px;
                        height: 230px;
                        border: 45px solid rgba(255, 255, 255, 0.04);
                        border-radius: 50%;
                    }

                    .demirsan-hr-info-content {
                        position: relative;
                        z-index: 2;
                    }

                    .demirsan-hr-info-label {
                        display: block;
                        margin-bottom: 10px;
                        color: #ff3131;
                        font-size: 19px;
                        font-weight: 600;
                    }

                    .demirsan-hr-info h3 {
                        margin: 0 0 22px;
                        color: #ffffff;
                        font-size: 34px;
                        font-weight: 700;
                        line-height: 1.25;
                    }

                    .demirsan-hr-info-description {
                        margin: 0 0 35px;
                        color: rgba(255, 255, 255, 0.75);
                        font-size: 16px;
                        line-height: 1.75;
                    }

                    .demirsan-hr-feature-list {
                        display: flex;
                        flex-direction: column;
                        gap: 18px;
                    }

                    .demirsan-hr-feature {
                        display: flex;
                        align-items: flex-start;
                        gap: 14px;
                    }

                    .demirsan-hr-feature-number {
                        flex: 0 0 34px;
                        width: 34px;
                        height: 34px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 50%;
                        background-color: #e60000;
                        color: #ffffff;
                        font-size: 14px;
                        font-weight: 700;
                    }

                    .demirsan-hr-feature h5 {
                        margin: 0 0 4px;
                        color: #ffffff;
                        font-size: 17px;
                        font-weight: 600;
                    }

                    .demirsan-hr-feature p {
                        margin: 0;
                        color: rgba(255, 255, 255, 0.65);
                        font-size: 14px;
                        line-height: 1.6;
                    }

                    /*
                     * Başvuru formu
                     */
                    .demirsan-hr-form-card {
                        width: 100%;
                        padding: 50px 45px;
                        border: 1px solid #f0dddd;
                        border-radius: 10px;
                        background-color: #fff2f2;
                    }

                    .demirsan-hr-form-title {
                        margin-bottom: 32px;
                    }

                    .demirsan-hr-form-title span {
                        display: block;
                        margin-bottom: 6px;
                        color: #e60000;
                        font-size: 19px;
                        font-weight: 600;
                    }

                    .demirsan-hr-form-title h3 {
                        margin: 0;
                        color: #0b1735;
                        font-size: 31px;
                        font-weight: 700;
                        line-height: 1.3;
                    }

                    .demirsan-hr-form-grid {
                        display: grid;
                        grid-template-columns: repeat(2, minmax(0, 1fr));
                        gap: 20px;
                    }

                    .demirsan-hr-field {
                        min-width: 0;
                    }

                    .demirsan-hr-field-full {
                        grid-column: 1 / -1;
                    }

                    .demirsan-hr-field label {
                        display: block;
                        margin-bottom: 8px;
                        color: #0b1735;
                        font-size: 15px;
                        font-weight: 600;
                    }

                    .demirsan-hr-field input,
                    .demirsan-hr-field textarea {
                        width: 100%;
                        margin: 0;
                        padding: 15px 17px;
                        border: 1px solid #e4dada;
                        border-radius: 6px;
                        outline: none;
                        background-color: #ffffff;
                        color: #0b1735;
                        font-size: 15px;
                        line-height: 1.5;
                        transition:
                            border-color 0.2s ease,
                            box-shadow 0.2s ease;
                    }

                    .demirsan-hr-field input {
                        height: 54px;
                    }

                    .demirsan-hr-field textarea {
                        min-height: 145px;
                        resize: vertical;
                    }

                    .demirsan-hr-field input:focus,
                    .demirsan-hr-field textarea:focus {
                        border-color: #e60000;
                        box-shadow: 0 0 0 3px rgba(230, 0, 0, 0.08);
                    }

                    /*
                     * Özel dosya yükleme alanı
                     */
                    .demirsan-cv-input {
                        position: absolute;
                        width: 1px;
                        height: 1px;
                        overflow: hidden;
                        opacity: 0;
                        pointer-events: none;
                    }

                    .demirsan-cv-upload {
                        width: 100%;
                        min-height: 120px;
                        padding: 22px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        border: 2px dashed #e3caca;
                        border-radius: 7px;
                        background-color: #ffffff;
                        text-align: center;
                        cursor: pointer;
                        transition:
                            border-color 0.2s ease,
                            background-color 0.2s ease;
                    }

                    .demirsan-cv-upload:hover {
                        border-color: #e60000;
                        background-color: #fffafa;
                    }

                    .demirsan-cv-icon {
                        width: 44px;
                        height: 44px;
                        margin-bottom: 10px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 50%;
                        background-color: #fff0f0;
                        color: #e60000;
                        font-size: 25px;
                        font-weight: 700;
                    }

                    .demirsan-cv-upload strong {
                        margin-bottom: 5px;
                        color: #0b1735;
                        font-size: 15px;
                    }

                    .demirsan-cv-upload span {
                        color: #6a7282;
                        font-size: 13px;
                        line-height: 1.5;
                    }

                    .demirsan-selected-file {
                        margin-top: 9px;
                        color: #0b1735 !important;
                        font-weight: 600;
                        overflow-wrap: anywhere;
                    }

                    .demirsan-file-error {
                        margin: 8px 0 0;
                        color: #d40000;
                        font-size: 13px;
                        font-weight: 500;
                    }

                    /*
                     * Onay kutusu
                     */
             
                    .demirsan-hr-submit {
                        width: 100%;
                        min-height: 55px;
                        padding: 14px 24px;
                        border: 0;
                        border-radius: 6px;
                        background-color: #e60000;
                        color: #ffffff;
                        font-size: 16px;
                        font-weight: 700;
                        cursor: pointer;
                        transition:
                            background-color 0.2s ease,
                            transform 0.2s ease;
                    }

                    .demirsan-hr-submit:hover {
                        background-color: #0b1735;
                        transform: translateY(-1px);
                    }

                    .demirsan-form-message {
                        margin: 18px 0 0;
                        padding: 13px 15px;
                        border: 1px solid #c8dfcf;
                        border-radius: 5px;
                        background-color: #effaf2;
                        color: #256337;
                        font-size: 14px;
                        line-height: 1.5;
                    }

                    @media (max-width: 991px) {
                        .demirsan-hr-area {
                            padding: 85px 0;
                        }

                        .demirsan-hr-info,
                        .demirsan-hr-form-card {
                            padding: 40px 32px;
                        }

                        .demirsan-hr-info h3 {
                            font-size: 29px;
                        }

                        .demirsan-hr-form-title h3 {
                            font-size: 27px;
                        }
                    }

                    @media (max-width: 767px) {
                        .demirsan-hr-area {
                            padding: 65px 0;
                        }

                        .demirsan-hr-intro {
                            font-size: 15px;
                        }

                        .demirsan-hr-row {
                            margin-top: 38px;
                        }

                        .demirsan-hr-info,
                        .demirsan-hr-form-card {
                            padding: 32px 23px;
                        }

                        .demirsan-hr-info h3 {
                            font-size: 26px;
                        }

                        .demirsan-hr-form-title h3 {
                            font-size: 24px;
                        }

                        .demirsan-hr-form-grid {
                            grid-template-columns: 1fr;
                            gap: 17px;
                        }

                        .demirsan-hr-field-full {
                            grid-column: auto;
                        }
                    }
                        /*
 * Özel CV yükleme alanı
 */
.demirsan-cv-input {
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    overflow: hidden !important;
    opacity: 0 !important;
    pointer-events: none !important;
}

.demirsan-cv-upload {
    position: relative;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 7px;

    width: 100%;
    min-height: 180px;
    margin: 0 !important;
    padding: 28px 20px !important;

    border: 2px dashed #e2bcbc !important;
    border-radius: 12px !important;
    background-color: #ffffff !important;

    text-align: center !important;
    cursor: pointer;
    overflow: hidden;

    transition:
        border-color 0.25s ease,
        background-color 0.25s ease,
        box-shadow 0.25s ease,
        transform 0.25s ease;
}

.demirsan-cv-upload:hover {
    border-color: #e60000 !important;
    background-color: #fffafa !important;
    box-shadow: 0 8px 22px rgba(230, 0, 0, 0.08);
    transform: translateY(-2px);
}

.demirsan-cv-upload:focus-within {
    border-color: #e60000 !important;
    box-shadow: 0 0 0 4px rgba(230, 0, 0, 0.08);
}

/* Label içindeki elemanların tema tarafından kaydırılmasını önler */
.demirsan-cv-upload > * {
    position: relative !important;
    inset: auto !important;
    float: none !important;
    transform: none;
}

.demirsan-cv-icon {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    flex: 0 0 54px;

    width: 54px;
    height: 54px;
    margin: 0 0 5px !important;
    padding: 0 !important;

    border-radius: 50%;
    background-color: #fff0f0 !important;
    color: #e60000 !important;

    transition:
        background-color 0.25s ease,
        color 0.25s ease,
        transform 0.25s ease;
}

.demirsan-cv-icon svg {
    display: block;
    width: 25px;
    height: 25px;
}

.demirsan-cv-upload:hover .demirsan-cv-icon {
    background-color: #e60000 !important;
    color: #ffffff !important;
    transform: translateY(-2px);
}

.demirsan-cv-title {
    display: block !important;
    width: 100%;
    margin: 0 !important;
    padding: 0 !important;

    color: #0b1735 !important;
    font-size: 16px !important;
    font-weight: 700 !important;
    line-height: 1.4 !important;
    text-align: center !important;
}

.demirsan-cv-description {
    display: block !important;
    width: 100%;
    margin: 0 !important;
    padding: 0 !important;

    color: #5c6678 !important;
    font-size: 13px !important;
    font-weight: 400 !important;
    line-height: 1.5 !important;
    text-align: center !important;
}

.demirsan-cv-formats {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;

    width: auto !important;
    margin-top: 4px !important;
    padding: 5px 11px !important;

    border-radius: 20px;
    background-color: #f5f5f7 !important;
    color: #6a7282 !important;

    font-size: 12px !important;
    font-weight: 500 !important;
    line-height: 1.4 !important;
    text-align: center !important;
}

.demirsan-selected-file {
    display: block !important;
    width: 100%;
    max-width: 420px;
    margin: 8px 0 0 !important;
    padding: 9px 12px !important;

    border: 1px solid #b8dec4;
    border-radius: 7px;
    background-color: #effaf2 !important;
    color: #256337 !important;

    font-size: 13px !important;
    font-weight: 600 !important;
    line-height: 1.4 !important;
    text-align: center !important;
    overflow-wrap: anywhere;
}

.demirsan-cv-upload.is-selected {
    border-style: solid !important;
    border-color: #a8d5b6 !important;
    background-color: #fbfffc !important;
}

.demirsan-cv-upload.is-selected .demirsan-cv-icon {
    background-color: #e5f7ea !important;
    color: #258344 !important;
}

.demirsan-file-error {
    margin: 8px 0 0;
    color: #d40000;
    font-size: 13px;
    font-weight: 500;
}

@media (max-width: 767px) {
    .demirsan-cv-upload {
        min-height: 165px;
        padding: 24px 15px !important;
    }

    .demirsan-cv-icon {
        flex-basis: 48px;
        width: 48px;
        height: 48px;
    }

    .demirsan-cv-title {
        font-size: 15px !important;
    }
}
    /* Checkbox satırı */
.demirsan-hr-field .demirsan-hr-consent {
  display: flex !important;
  align-items: flex-start !important;
  gap: 11px;

  width: 100%;
  margin: 0;
  padding: 0;
}

/* Genel input stillerinden checkbox'ı korur */
.demirsan-hr-field
  .demirsan-hr-consent
  .demirsan-hr-consent-checkbox {
  position: static !important;

  display: block !important;
  flex: 0 0 18px !important;

  width: 18px !important;
  min-width: 18px !important;
  max-width: 18px !important;

  height: 18px !important;
  min-height: 18px !important;
  max-height: 18px !important;

  margin: 2px 0 0 !important;
  padding: 0 !important;

  opacity: 1 !important;
  visibility: visible !important;

  border: initial !important;
  border-radius: 3px;

  background: initial !important;
  box-shadow: none !important;

  transform: none !important;

  appearance: auto !important;
  -webkit-appearance: checkbox !important;

  accent-color: #e60000;

  cursor: pointer;
}

.demirsan-hr-consent-content {
  flex: 1;
  min-width: 0;

  margin: 0;
  padding: 0;

  color: #5c6678;

  font-size: 13px;
  font-weight: 400;
  line-height: 1.6;
}

/* Genel label stilini ez */
.demirsan-hr-field
  .demirsan-hr-consent-content
  label {
  display: inline !important;

  margin: 0 !important;
  padding: 0 !important;

  color: #5c6678 !important;

  font-size: 13px !important;
  font-weight: 400 !important;
  line-height: 1.6 !important;

  cursor: pointer;
}



.demirsan-hr-consent-content span {
  color: inherit;
  font-size: inherit;
  line-height: inherit;
}

.demirsan-hr-consent-checkbox:focus-visible {
  outline: 2px solid rgba(230, 0, 0, 0.35);
  outline-offset: 2px;
}

.demirsan-hr-consent-checkbox:disabled {
  cursor: not-allowed;
  opacity: 0.6 !important;
}

@media (max-width: 767px) {
  .demirsan-hr-field .demirsan-hr-consent {
    gap: 9px;
  }

  .demirsan-hr-consent-content,
  .demirsan-hr-field
    .demirsan-hr-consent-content
    label {
    font-size: 12.5px !important;
    line-height: 1.55 !important;
  }
}
  .demirsan-hr-submit:disabled {
  background-color: #b9b9b9 !important;
  color: #ffffff !important;
  cursor: not-allowed !important;
  opacity: 0.75;
  transform: none !important;
}

.demirsan-hr-submit:disabled:hover {
  background-color: #b9b9b9 !important;
  transform: none !important;
}
  .demirsan-contract-link {
  display: inline !important;

  width: auto !important;
  min-width: 0 !important;
  max-width: none !important;
  height: auto !important;
  min-height: 0 !important;

  margin: 0 3px !important;
  padding: 0 !important;

  border: 0 !important;
  border-radius: 0 !important;

  background: transparent !important;
  box-shadow: none !important;

  color: #e60000 !important;

  font-family: inherit !important;
  font-size: inherit !important;
  font-weight: 600 !important;
  line-height: inherit !important;

  text-decoration: underline;
  text-underline-offset: 2px;

  vertical-align: baseline;

  cursor: pointer;
}

.demirsan-contract-link:hover {
  color: #0b1735 !important;
  background: transparent !important;
}

  /*
|--------------------------------------------------------------------------
| AYDINLATMA METNİ MODAL
|--------------------------------------------------------------------------
*/

.demirsan-contract-overlay {
  position: fixed;

  inset: 0;

  z-index: 999999;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 24px;

  background: rgba(7, 16, 36, 0.72);

  backdrop-filter: blur(4px);
}

.demirsan-contract-modal {
  position: relative;

  display: flex;
  flex-direction: column;

  width: min(900px, 100%);
  max-height: calc(100vh - 48px);

  overflow: hidden;

  border-radius: 14px;

  background: #ffffff;

  box-shadow:
    0 25px 80px
    rgba(0, 0, 0, 0.28);
}

.demirsan-contract-header {
  display: flex;

  align-items: flex-start;
  justify-content: space-between;

  gap: 20px;

  padding: 22px 25px;

  border-bottom: 1px solid #eceef2;

  background: #ffffff;
}

.demirsan-contract-heading {
  min-width: 0;
}

.demirsan-contract-label {
  display: block;

  margin-bottom: 4px;

  color: #e60000;

  font-size: 12px;
  font-weight: 700;

  letter-spacing: 0.6px;

  text-transform: uppercase;
}

.demirsan-contract-title {
  margin: 0;

  color: #0b1735;

  font-size: 21px;
  font-weight: 700;

  line-height: 1.35;
}

.demirsan-contract-close {
  display: flex;

  align-items: center;
  justify-content: center;

  flex: 0 0 38px;

  width: 38px;
  height: 38px;

  margin: 0;
  padding: 0;

  border: 0;
  border-radius: 50%;

  background: #f4f5f7;
  color: #5d6677;

  font-size: 24px;
  line-height: 1;

  cursor: pointer;

  transition:
    background-color .2s ease,
    color .2s ease;
}

.demirsan-contract-close:hover {
  background: #e60000;
  color: #ffffff;
}

.demirsan-contract-body {
  flex: 1;

  padding: 26px;

  overflow-y: auto;

  color: #4f5b6e;

  font-size: 14px;
  line-height: 1.8;
}

.demirsan-contract-content {
  color: #4f5b6e;

  font-size: 14px;
  line-height: 1.8;
}

.demirsan-contract-content p {
  margin: 0 0 14px;
}

.demirsan-contract-content h1,
.demirsan-contract-content h2,
.demirsan-contract-content h3,
.demirsan-contract-content h4,
.demirsan-contract-content h5,
.demirsan-contract-content h6 {
  margin-top: 16px !important;
  margin-bottom: 8px !important;
  color: #0b1735 !important;
  font-weight: 700 !important;
  line-height: 1.4 !important;
  letter-spacing: 0 !important;
  text-transform: none !important;
  background: none !important;
}

body .demirsan-contract-modal .demirsan-contract-content h1 { font-size: 20px !important; }
body .demirsan-contract-modal .demirsan-contract-content h2 { font-size: 18px !important; }
body .demirsan-contract-modal .demirsan-contract-content h3,
body .demirsan-contract-modal .demirsan-contract-content h4 { font-size: 16px !important; }
body .demirsan-contract-modal .demirsan-contract-content h5,
body .demirsan-contract-modal .demirsan-contract-content h6 { font-size: 14px !important; }

body .demirsan-contract-modal .demirsan-contract-content h1::before,
body .demirsan-contract-modal .demirsan-contract-content h1::after,
body .demirsan-contract-modal .demirsan-contract-content h2::before,
body .demirsan-contract-modal .demirsan-contract-content h2::after,
body .demirsan-contract-modal .demirsan-contract-content h3::before,
body .demirsan-contract-modal .demirsan-contract-content h3::after {
  content: none !important;
  display: none !important;
  background: none !important;
}

.demirsan-contract-content ul,
.demirsan-contract-content ol {
  padding-left: 22px;
}

.demirsan-contract-content a {
  color: #e60000;
}

.demirsan-contract-loading,
.demirsan-contract-error,
.demirsan-contract-empty {
  padding: 45px 15px;

  text-align: center;

  font-size: 14px;
}

.demirsan-contract-loading {
  color: #657083;
}

.demirsan-contract-error {
  color: #d40000;
}

.demirsan-contract-empty {
  color: #7a8494;
}

.demirsan-contract-footer {
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 16px 25px;

  border-top: 1px solid #eceef2;

  background: #fafafa;
}

.demirsan-contract-footer-button {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;

  width: auto !important;
  min-width: 90px !important;
  max-width: none !important;

  padding: 9px 18px !important;

  border: 0;
  border-radius: 6px;

  background: #0b1735;
  color: #ffffff;

  font-size: 13px;
  font-weight: 600;

  cursor: pointer;
}

.demirsan-contract-footer-button:hover {
  background: #e60000;
}

.demirsan-contract-footer-button:hover {
  background: #e60000;
}


@media (max-width: 767px) {
  .demirsan-contract-overlay {
    padding: 10px;
  }

  .demirsan-contract-modal {
    max-height: calc(100vh - 20px);

    border-radius: 10px;
  }

  .demirsan-contract-header {
    padding: 17px;
  }

  .demirsan-contract-title {
    font-size: 18px;
  }

  .demirsan-contract-body {
    padding: 18px;

    font-size: 13px;
  }

  .demirsan-contract-footer {
    padding: 13px 17px;
  }


}
  @media (max-width: 767px) {
  .demirsan-contract-footer {
    padding: 13px 17px;
  }

  .demirsan-contract-footer-button {
    width: auto !important;
    min-width: 90px !important;
  }
}
                `}
      </style>

      {successPopupOpen && (
        <div
          style={{
            position: "fixed", inset: 0, zIndex: 999999,
            background: "rgba(0,0,0,0.65)",
            display: "flex", alignItems: "center", justifyContent: "center",
            padding: "20px",
          }}
          onClick={(e) => { if (e.target === e.currentTarget) closeSuccessPopup(); }}
        >
          <div style={{
            background: "#fff", borderRadius: "14px", maxWidth: "560px",
            width: "100%", boxShadow: "0 24px 60px rgba(0,0,0,0.4)",
            overflow: "hidden", animation: "dsn-slide-up 0.25s ease",
          }}>
            {/* Header */}
            <div style={{
              background: "#e20614", padding: "28px 32px 22px",
              textAlign: "center",
            }}>
              <div style={{
                width: "56px", height: "56px", borderRadius: "50%",
                background: "rgba(255,255,255,0.2)",
                display: "flex", alignItems: "center", justifyContent: "center",
                margin: "0 auto 14px",
              }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              </div>
              <h3 style={{ color: "#fff", margin: 0, fontSize: "20px", fontWeight: 700 }}>
                Başvurunuz Alındı
              </h3>
            </div>

            {/* Body */}
            <div style={{ padding: "28px 32px", color: "#333", lineHeight: 1.75 }}>
              <p style={{ margin: "0 0 14px", fontSize: "15px" }}>
                Merhaba <strong>{applicantName}</strong>,
              </p>
              <p style={{ margin: "0 0 14px", fontSize: "15px" }}>
                İş başvurunuz ve özgeçmişiniz başarıyla tarafımıza ulaştı.
              </p>
              <p style={{ margin: "0 0 24px", fontSize: "15px" }}>
                Başvurunuz insan kaynakları ekibimiz tarafından değerlendirilecektir. Uygun görülmesi durumunda sizinle iletişime geçilecektir.
              </p>
              <p style={{ margin: "0 0 6px", fontSize: "15px" }}>Saygılarımızla,</p>
              <p style={{ margin: 0, fontSize: "15px", fontWeight: 700 }}>Demirsan Soğuk Çekme San. ve Tic. A.Ş.</p>
            </div>

            {/* Footer */}
            <div style={{
              padding: "0 32px 28px", display: "flex", justifyContent: "center",
            }}>
              <button
                onClick={closeSuccessPopup}
                style={{
                  background: "#e20614", color: "#fff", border: "none",
                  borderRadius: "8px", padding: "11px 36px", fontSize: "15px",
                  fontWeight: 600, cursor: "pointer",
                }}
              >
                Tamam
              </button>
            </div>
          </div>
        </div>
      )}

      <HeaderOne />

      <Breadcrumb title="İnsan Kaynakları" breadcrumbs={breadcrumbs} />

      <section className="demirsan-hr-area">
        <div className="container">
          <div className="rts-title-area text-center demirsan-hr-clean-title">
            <p className="pre-title">İNSAN KAYNAKLARI</p>

            <h2 className="title">DEMİRSAN Ekibine Katılın</h2>

            <p className="demirsan-hr-intro">
              Bilginiz, deneyiminiz ve hedeflerinizle Demirsan’ın gelişimine
              katkı sağlamak için özgeçmişinizi bizimle paylaşabilirsiniz.
            </p>
          </div>

          <div className="row g-5 demirsan-hr-row">
            {/* Sol bilgi alanı */}
            <div className="col-lg-5 col-12">
              <div className="demirsan-hr-info">
                <div className="demirsan-hr-info-content">
                  <span className="demirsan-hr-info-label">
                    İnsan Kaynakları
                  </span>

                  <h3>Geleceğinizi birlikte şekillendirelim</h3>

                  <p className="demirsan-hr-info-description">
                    Açık pozisyonlarımız ve genel iş başvurularınız için formu
                    doldurarak özgeçmişinizi iletebilirsiniz.
                  </p>

                  <div className="demirsan-hr-feature-list">
                    <div className="demirsan-hr-feature">
                      <span className="demirsan-hr-feature-number">1</span>

                      <div>
                        <h5>Başvurunuzu oluşturun</h5>
                        <p>
                          İletişim bilgilerinizi ve mesajınızı eksiksiz
                          doldurun.
                        </p>
                      </div>
                    </div>

                    <div className="demirsan-hr-feature">
                      <span className="demirsan-hr-feature-number">2</span>

                      <div>
                        <h5>CV’nizi yükleyin</h5>
                        <p>
                          Güncel özgeçmişinizi PDF, DOC veya DOCX formatında
                          ekleyin.
                        </p>
                      </div>
                    </div>

                    <div className="demirsan-hr-feature">
                      <span className="demirsan-hr-feature-number">3</span>

                      <div>
                        <h5>Değerlendirme süreci</h5>
                        <p>
                          Uygun başvurular insan kaynakları ekibimiz tarafından
                          değerlendirilir.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Başvuru formu */}
            <div className="col-lg-7 col-12">
              <div className="demirsan-hr-form-card">
                <div className="demirsan-hr-form-title">
                  <span>İş Başvuru Formu</span>

                  <h3>Başvurunuzu Bize Gönderin</h3>
                </div>

                <form onSubmit={handleSubmit} encType="multipart/form-data">
                  <div className="demirsan-hr-form-grid">
                    <div className="demirsan-hr-field">
                      <label htmlFor="hr-name">Ad</label>

                      <input
                        id="hr-name"
                        type="text"
                        name="name"
                        placeholder="Adınız"
                        autoComplete="given-name"
                        inputMode="text"
                        pattern="[A-Za-zÇĞİÖŞÜçğıöşüÂâÎîÛû' -]+"
                        title="Ad alanında yalnızca harf kullanabilirsiniz."
                        onInput={handlePersonNameInput}
                        required
                        disabled={isSubmitting}
                      />
                    </div>

                    <div className="demirsan-hr-field">
                      <label htmlFor="hr-surname">Soyad</label>

                      <input
                        id="hr-surname"
                        type="text"
                        name="surname"
                        placeholder="Soyadınız"
                        autoComplete="family-name"
                        inputMode="text"
                        pattern="[A-Za-zÇĞİÖŞÜçğıöşüÂâÎîÛû' -]+"
                        title="Soyad alanında yalnızca harf kullanabilirsiniz."
                        onInput={handlePersonNameInput}
                        required
                        disabled={isSubmitting}
                      />
                    </div>

                    <div className="demirsan-hr-field">
                      <label htmlFor="hr-phone">Telefon</label>

                      <input
                        id="hr-phone"
                        type="tel"
                        name="phone"
                        placeholder="5XX XXX XX XX"
                        autoComplete="tel"
                        inputMode="numeric"
                        maxLength={13}
                        pattern="5[0-9]{2} [0-9]{3} [0-9]{2} [0-9]{2}"
                        title="Telefon numarasını 500 000 00 00 formatında giriniz."
                        onInput={handleHrPhoneInput}
                        required
                        disabled={isSubmitting}
                      />
                    </div>

                    <div className="demirsan-hr-field">
                      <label htmlFor="hr-email">E-posta</label>

                      <input
                        id="hr-email"
                        type="email"
                        name="email"
                        placeholder="ornek@mail.com"
                        autoComplete="email"
                        inputMode="email"
                        pattern="[^@\s]+@[^@\s]+\.[^@\s]+"
                        title="Geçerli bir e-posta adresi giriniz. E-posta adresinde @ karakteri bulunmalıdır."
                        onInput={handleHrEmailInput}
                        required
                        disabled={isSubmitting}
                      />
                    </div>

                    <div className="demirsan-hr-field demirsan-hr-field-full">
                      <label htmlFor="hr-message">Mesajınız</label>

                      <textarea
                        id="hr-message"
                        name="message"
                        placeholder="Kendiniz, deneyimleriniz veya başvurmak istediğiniz alan hakkında bilgi verebilirsiniz."
                        required
                      />
                    </div>

                    <div className="demirsan-hr-field demirsan-hr-field-full">
                      <label>CV Yükleme</label>

                      <input
                        id="hr-cv"
                        className="demirsan-cv-input"
                        type="file"
                        name="cv"
                        accept=".pdf,.doc,.docx"
                        onChange={handleFileChange}
                        required
                      />

                      <label
                        className={`demirsan-cv-upload ${
                          selectedFile ? "is-selected" : ""
                        }`}
                        htmlFor="hr-cv"
                      >
                        <span className="demirsan-cv-icon" aria-hidden="true">
                          {selectedFile ? (
                            <svg
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2.3"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M20 6 9 17l-5-5" />
                            </svg>
                          ) : (
                            <svg
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M12 16V4" />
                              <path d="m7 9 5-5 5 5" />
                              <path d="M5 20h14" />
                            </svg>
                          )}
                        </span>

                        <strong className="demirsan-cv-title">
                          {selectedFile
                            ? "CV dosyanız seçildi"
                            : "CV dosyanızı yüklemek için tıklayın"}
                        </strong>

                        {!selectedFile && (
                          <span className="demirsan-cv-description">
                            Bilgisayarınızdan özgeçmiş dosyanızı seçin
                          </span>
                        )}

                        <span className="demirsan-cv-formats">
                          PDF, DOC veya DOCX · En fazla 5 MB
                        </span>

                        {selectedFile && (
                          <span className="demirsan-selected-file">
                            {selectedFile.name}
                          </span>
                        )}
                      </label>

                      {fileError && (
                        <p className="demirsan-file-error">{fileError}</p>
                      )}
                    </div>

                    <div className="demirsan-hr-field demirsan-hr-field-full">
                      <div className="demirsan-hr-consent">
                        <input
                          id="hr-consent"
                          className="demirsan-hr-consent-checkbox"
                          type="checkbox"
                          name="consent"
                          value="true"
                          required
                          checked={isConsentChecked}
                          disabled={isSubmitting}
                          onChange={(event) => {
                            setIsConsentChecked(event.target.checked);

                            if (event.target.checked) {
                              setFormMessage("");
                              setFormMessageType("");
                            }
                          }}
                        />
                        <div className="demirsan-hr-consent-content">
                          <label htmlFor="hr-consent">
                            İş başvurum kapsamında paylaştığım kişisel verilerin
                            ve özgeçmişimin, insan kaynakları süreçlerinin
                            yürütülmesi amacıyla işlenmesini kabul
                            ediyorum.{" "}
                          </label>

                          <button
                            type="button"
                            className="demirsan-contract-link"
                            onClick={openContractModal}
                          >
                            Aydınlatma Metni
                          </button>

                          <span>’ni okudum.</span>
                        </div>
                      </div>
                    </div>

                    <div className="demirsan-hr-field demirsan-hr-field-full">
                      <button
                        type="submit"
                        className="demirsan-hr-submit"
                        disabled={isSubmitting || !isConsentChecked}
                      >
                        {isSubmitting ? "Gönderiliyor..." : "Başvuruyu Gönder"}
                      </button>
                      {formMessage && (
                        <p
                          className={`demirsan-form-message ${
                            formMessageType === "error" ? "error" : "success"
                          }`}
                          role={
                            formMessageType === "error" ? "alert" : "status"
                          }
                        >
                          {formMessage}
                        </p>
                      )}
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ====================================================
    AYDINLATMA METNİ MODAL
===================================================== */}
      {contractModalOpen && (
        <div
          className="demirsan-contract-overlay"
          onMouseDown={(event) => {
            if (event.target === event.currentTarget) {
              closeContractModal();
            }
          }}
        >
          <div
            className="demirsan-contract-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="contract-modal-title"
          >
            {/* HEADER */}
            <div className="demirsan-contract-header">
              <div className="demirsan-contract-heading">
                <span className="demirsan-contract-label">
                  Kişisel Verilerin Korunması
                </span>

                <h3
                  id="contract-modal-title"
                  className="demirsan-contract-title"
                >
                  {contractData.title || "Aydınlatma Metni"}
                </h3>
              </div>

              <button
                type="button"
                className="demirsan-contract-close"
                onClick={closeContractModal}
                aria-label="Kapat"
              >
                ×
              </button>
            </div>

            {/* CONTENT */}
            <div className="demirsan-contract-body">
              {contractLoading ? (
                <div className="demirsan-contract-loading">
                  Aydınlatma metni yükleniyor...
                </div>
              ) : contractError ? (
                <div className="demirsan-contract-error">{contractError}</div>
              ) : contractData.editor ? (
                <div
                  className="demirsan-contract-content"
                  dangerouslySetInnerHTML={{
                    __html: contractData.editor,
                  }}
                />
              ) : (
                <div className="demirsan-contract-empty">
                  Aydınlatma metni bulunamadı.
                </div>
              )}
            </div>

            {/* FOOTER */}
            <div className="demirsan-contract-footer">
              <button
                type="button"
                className="demirsan-contract-footer-button"
                onClick={closeContractModal}
              >
                Kapat
              </button>
            </div>
          </div>
        </div>
      )}
      <FooterOne />
    </div>
  );
}

export default HumanResources;
